import { memo, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import NoResults from './NoResults';

import { When } from 'react-if';

import classNames from 'classnames';
import './ResultBlock.scss';

const EMPTY_ARRAY = [];

const ResultBlock = ({ closeSearch, isFetching = false, itemRenderer, query = "", results = EMPTY_ARRAY, title = "", seeAllUrl = undefined, isRecent = false }) => {
  const navigate = useNavigate()
  const resultsStyle = useMemo(() => {
    if(results.length > 0) {
      if(isRecent) {
        return {
          height: results.length * (32 + 4) + 2 * 16 - 16
        }  
      }
      return {
        height: results.length * (32 + 4) + 2 * 16 - 16 + 32
      }
    } else if(results.length === 0 && !isFetching) {
      return {
        height: 2 * 16 + 64
      }
    } else {
      return { height: 0 };
    }
  }, [results.length, isFetching, isRecent]),
  isHidden = useMemo(() => {
    if(isRecent) {
      return query !== ""
    }
    return isFetching && results?.length === 0 || query === ""
  }, [isFetching, isRecent, query, results?.length])
  return (
    <div className={classNames("search-all__content__results__block", { "search-all__content__results__block--is-hidden": isHidden })}>
      <When condition={!isFetching}>
        {() => (
          <div className="search-all__content__results__block__header">
            <div className="search-all__content__results__block__header__name">
              {title}
            </div>
            <div className="search-all__content__results__block__header__line"/>
          </div>
        )}
      </When>
      <div 
          className="search-all__content__results__block__body"
          style={resultsStyle}
      >
        <When condition={results?.length > 0 || isFetching}>
          {() => results.map((item, index) => itemRenderer(item, index))}
        </When>
        <When condition={results?.length > 0 && !isFetching && seeAllUrl}>
          {() => (
            <a
                className="search-all__content__results__block__body__see-all"
                href={`${window.location.protocol}//${window.location.host}${seeAllUrl}`}
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  navigate(seeAllUrl)
                  closeSearch()
                }}
            >
              See all results
            </a>
          )}
        </When>
        <When condition={results?.length === 0 && !isFetching}>
          {() => (
            <div className="search-all__content__results__block__body__container">
              <NoResults/>
            </div>
          )}
        </When>
      </div>
    </div>
  )
}

ResultBlock.propTypes = {
  closeSearch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  isRecent: PropTypes.bool,
  itemRenderer: PropTypes.func.isRequired,
  query: PropTypes.string,
  results: PropTypes.array,
  seeAllUrl: PropTypes.string,
  title: PropTypes.string,
}

export default memo(ResultBlock);